import { loadStripe } from '@stripe/stripe-js';

const getStripeInstance = async ({
  vendorPlatformKey,
  vendorMerchantId,
}: {
  vendorPlatformKey: string;
  vendorMerchantId?: string;
}) =>
  loadStripe(vendorPlatformKey, {
    locale: 'en',
    stripeAccount: vendorMerchantId,
  });

export default getStripeInstance;
